import React, { useState } from 'react';
import styles from './CastSection.module.css';

const INITIAL_CAST_COUNT = 8;

function CastImage({ person, className }) {
    const [failed, setFailed] = useState(false);
    const label = `${person.name} as ${person.character}`;
    return person.profileImageUrl && !failed ? (
        <img className={className} src={person.profileImageUrl} alt={label} onError={() => setFailed(true)} />
    ) : (
        <div className={`${className} ${styles.fallback}`} role="img" aria-label={`${label}, profile image unavailable`}>
            <span aria-hidden="true">{person.name.slice(0, 1).toUpperCase()}</span>
        </div>
    );
}

function CastPerson({ person, full = false }) {
    return (
        <article className={full ? styles.fullCard : styles.card} aria-label={`${person.name} as ${person.character}`}>
            <CastImage person={person} className={full ? styles.fullImage : styles.image} />
            <div className={styles.personText}>
                <strong title={person.name}>{person.name}</strong>
                <span title={person.character}>{person.character}</span>
            </div>
        </article>
    );
}

export default function CastSection({ cast, media, kind, onFullCastOpened }) {
    const [showFull, setShowFull] = useState(false);
    if (!Array.isArray(cast) || cast.length === 0) return null;
    const openFull = () => {
        setShowFull(true);
        onFullCastOpened?.({ mediaId: media?.tmdbId, mediaType: kind, mediaTitle: media?.title, castCount: cast.length });
    };

    return (
        <section className={styles.section} aria-labelledby="cast-heading">
            <div className={styles.headingRow}>
                <h2 id="cast-heading">Cast</h2>
                {cast.length > INITIAL_CAST_COUNT && <button type="button" onClick={openFull}>See Full Cast</button>}
            </div>
            <div className={styles.row} tabIndex="0" aria-label="Principal cast">
                {cast.slice(0, INITIAL_CAST_COUNT).map(person => <CastPerson key={person.id} person={person} />)}
            </div>
            {showFull && (
                <div className={styles.backdrop} role="presentation" onMouseDown={() => setShowFull(false)}>
                    <div className={styles.modal} role="dialog" aria-modal="true" aria-labelledby="full-cast-heading" onMouseDown={e => e.stopPropagation()}>
                        <div className={styles.headingRow}>
                            <h2 id="full-cast-heading">Full Cast</h2>
                            <button type="button" onClick={() => setShowFull(false)} aria-label="Close full cast">Close</button>
                        </div>
                        <div className={styles.fullGrid}>{cast.map(person => <CastPerson key={person.id} person={person} full />)}</div>
                    </div>
                </div>
            )}
        </section>
    );
}
